import { render, staticRenderFns } from "./detailsTopic.vue?vue&type=template&id=3e5a3584&scoped=true"
import script from "./detailsTopic.vue?vue&type=script&lang=js"
export * from "./detailsTopic.vue?vue&type=script&lang=js"
import style0 from "./detailsTopic.vue?vue&type=style&index=0&id=3e5a3584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a3584",
  null
  
)

export default component.exports